import { useQuery as useTanStackQuery } from '@tanstack/react-query';

import useFunnelMealPlan from 'hooks/useFunnelMealPlan';
import { getPartnership } from 'services/RequestService/endpoints/signUp';

const usePartnershipQuery = name => {
  const mealPlanSlug = useFunnelMealPlan(); // intended for use only inside the funnel because we get the mealPlanSlug from useFunnelMealPlan(); which is only available inside the funnel

  return useTanStackQuery({
    queryKey: ['partnership', { name, mealPlanSlug }],
    queryFn: ({ queryKey }) => {
      const [, { name, mealPlanSlug }] = queryKey;
      return getPartnership({
        params: {
          partnership: {
            name: name,
            mealPlanSlug: mealPlanSlug,
          },
        },
      });
    },
    staleTime: 1000 * 60 * 10, // Read from cache for 10 minutes
    enabled: Boolean(name) && Boolean(mealPlanSlug), // Only run if both name and mealPlanSlug are present
  });
};

export default usePartnershipQuery;
